import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const ModalFooter = forwardRef<HTMLDivElement, BSDiv>(
  ({ className = "", children, ...props }, ref) => (
    <div {...props} className={`modal-footer ${className}`} ref={ref}>
      {children}
    </div>
  )
);